import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { useCumprirTarefa, useMarcasTarefa } from '@/hooks/useTarefas';

/**
 * FINALIZAR DENTRO DA NOTA (Douglas 28/09/2026): "criar dentro da nota um
 * botão de finalizar tarefa, um botão sutil — isso ajudaria muito eles a
 * resolver e não ficar coisa pendente". Aparece na nota que a tarefa deixou na
 * conversa e na nota da ajuda que respondeu a ela — só para o dono da tarefa,
 * que é quem finaliza. Some quando a tarefa fecha.
 */
export function FinalizarTarefaNaNota({ mensagemId, conversaId, corpo }: { mensagemId: string; conversaId: string; corpo: string | null | undefined }) {
  const marcas = useMarcasTarefa();
  const { toast } = useToast();
  const cumprir = useCumprirTarefa();
  const [aberto, setAberto] = useState(false);
  const [texto, setTexto] = useState('');

  const texto0 = corpo || '';
  const minhas = (marcas.data ?? []).filter((m) => m.papel === 'minha');
  const tarefa = minhas.find((m) => m.nota_id === mensagemId)
    ?? (texto0.startsWith('🤝 AJUDA NA TAREFA')
      ? minhas.find((m) => m.conversa_id === conversaId && texto0.includes(m.titulo))
      : undefined);
  if (!tarefa) return null;

  const salvar = async () => {
    const nota = texto.trim();
    if (!nota) { toast({ title: 'Diga o que foi feito', variant: 'destructive' }); return; }
    try {
      await cumprir.mutateAsync({ id: tarefa.id, nota });
      toast({ title: 'Tarefa finalizada' });
      setAberto(false); setTexto('');
    } catch (e) {
      toast({ title: 'Não foi possível finalizar', description: (e as Error).message, variant: 'destructive' });
    }
  };

  if (!aberto) {
    return (
      <button type="button" onClick={() => setAberto(true)}
        className="mt-1 inline-flex items-center gap-1 text-[10.5px] font-semibold text-primary/80 hover:text-primary hover:underline">
        <CheckCircle2 className="h-3 w-3" /> Finalizar tarefa
      </button>
    );
  }
  return (
    <div className="mt-1.5 space-y-1.5">
      <textarea value={texto} onChange={(e) => setTexto(e.target.value)} rows={2} autoFocus
        placeholder="O que foi feito — é o que fica no histórico"
        className="w-full resize-none rounded-md border border-border bg-background px-2 py-1.5 text-[11.5px] focus:outline-none focus:ring-1 focus:ring-primary" />
      <div className="flex justify-end gap-1.5">
        <Button type="button" variant="outline" className="h-[26px] px-2 text-[11px]" disabled={cumprir.isPending}
          onClick={() => { setAberto(false); setTexto(''); }}>Cancelar</Button>
        <Button type="button" className="h-[26px] gap-1 px-2 text-[11px] text-white" disabled={cumprir.isPending} onClick={salvar}>
          <CheckCircle2 className="h-3 w-3" />{cumprir.isPending ? 'Finalizando…' : 'Finalizar'}
        </Button>
      </div>
    </div>
  );
}
